import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectTripCancellationStep = (state) => state.get('tripCancellationStep');

const makeSelectTripCancellationStep = () => createSelector(
  selectTripCancellationStep,
  (selectTripCancellationSate) => ({
    tripCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'tripCancellation']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasons: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasons']),
      ''
    ),

    schoolName: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'schoolName']),
      ''
    ),

    schoolNameForInterruption: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'schoolNameForInterruption']),
      ''
    ),

    schoolNameForDelay: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'schoolNameForInterruption']),
      ''
    ),

    areYouInterruptingTheTripDueToMedicalReasons: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'areYouInterruptingTheTripDueToMedicalReasons']),
      ''
    ),

    companyNameTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'companyNameTravelCancellation']),
      ''
    ),

    addressTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'addressTravelCancellation']),
      ''
    ),

    cityTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'cityTravelCancellation']),
      ''
    ),

    stateTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'stateTravelCancellation']),
      ''
    ),
    zipCodeTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'zipCodeTravelCancellation']),
      ''
    ),

    contactTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'contactTravelCancellation']),
      ''
    ),

    phoneNumberTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'phoneNumberTravelCancellation']),
      ''
    ),

    includedInPackageTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'includedInPackageTravelCancellation']),
      ''
    ),

    dateTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'dateTravelCancellation']),
      ''
    ),

    reasonForTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'reasonForTravelCancellation']),
      ''
    ),

    nameOfPersonHavingSicknessTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'nameOfPersonHavingSicknessTravelCancellation']),
      ''
    ),

    dateOfBirthTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'dateOfBirthTravelCancellation']),
      ''
    ),

    relationshipToClaimantTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'relationshipToClaimantTravelCancellation']),
      ''
    ),

    dateSicknessOrInjuryBeganTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'dateSicknessOrInjuryBeganTravelCancellation']),
      ''
    ),

    dateEndedTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'dateEndedTravelCancellation']),
      ''
    ),

    natureOfSicknessOrInjuryTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'natureOfSicknessOrInjuryTravelCancellation']),
      ''
    ),

    fromDateTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'fromDateTravelCancellation']),
      ''
    ),

    toDateTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'toDateTravelCancellation']),
      ''
    ),

    dateOfInitialPaymentDepositTravelCancellation: mapWithDefault(
      selectTripCancellationSate,
      () => selectTripCancellationSate.getIn(['form', 'dateOfInitialPaymentDepositTravelCancellation']),
      ''
    ),

    // Airline Reissue Or Cancellation Fees
    areYouClaimingForAirlineReissueOrCancellationFees: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'areYouClaimingForAirlineReissueOrCancellationFees']), ''),

    // Reinstate Frequent Traveler Awards
    areYouClaimingForReinstateFrequentTravelerAwards: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'areYouClaimingForReinstateFrequentTravelerAwards']), ''),

    lossInformationItemsTravelCancellation: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'lossInformationItemsTravelCancellation']) && selectTripCancellationSate.getIn(['form', 'lossInformationItemsTravelCancellation']).toJS(), ''),
    insuredsTravelCancellation: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'insuredsTravelCancellation']) && selectTripCancellationSate.getIn(['form', 'insuredsTravelCancellation']).toJS(), ''),

    companyNameLoss: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(selectTripCancellationSate, () => selectTripCancellationSate.getIn(['form', 'enableTime']), null),
  })
);

const makeSelectTripCancellationStepErrors = () =>
  createSelector(selectTripCancellationStep, (state) => state.get('errors'));

export {
  makeSelectTripCancellationStep,
  makeSelectTripCancellationStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/selectors.js